import { useState, useEffect } from 'react';
import httpService from 'services/httpService';

/**
 * Hook to fetch and provide platform settings.
 * Settings are cached to avoid redundant API calls.
 *
 * @returns {{ settings: Object|null, loading: boolean, error: Error|null }}
 */
export const usePlatformSettings = () => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await httpService.get('/api/platform-settings/');
                setSettings(response.data);
            } catch (err) {
                console.error('Failed to fetch platform settings:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    return { settings, loading, error };
};
